import useAnalytics from "hooks/useAnalytics";

import { ANALYTICS } from "./constants";

const useRoleUsedByAnalytics = () => {
  return useAnalytics({
    page: ANALYTICS.analyticsPage,
  });
};

export default useRoleUsedByAnalytics;
